export default {"src":"/_next/static/media/handHeart_24.a9b26af6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};